import { useContext } from "react";
import { CardContext } from "context/cardContext";

export const useCardContext = () => {
  const context = useContext(CardContext);

  return context;
};